export const HORDE_GLOSSARY_A = [
    {
        aliases: [],
        definition:
            "The 1-4(+GM) player co-op game mode layered on 40K 11th-edition core rules where one 'Horde' side is AI-piloted.",
        sectionId: 'intro',
        term: 'Horde Mode',
    },
    {
        aliases: ['1,000pt Incursion', '2,000pt Strike Force', 'game size'],
        definition: 'The two supported game sizes: 1,000pt (Incursion) or 2,000pt (Strike Force).',
        sectionId: '1',
        term: 'Incursion / Strike Force',
    },
    {
        aliases: ['Detachment Points', 'DP'],
        definition:
            "Standard 40K detachment-rule currency; in Horde Mode it is set by total game size, not each player's individual point share.",
        sectionId: '1',
        term: 'Detachment Points (DP)',
    },
    {
        aliases: ['Horde Faction(s)'],
        definition:
            "The single 40K faction (of 22, or multiple) chosen to supply the Horde's spawns and Primary Faction Rule.",
        sectionId: '1',
        term: 'Horde faction',
    },
    {
        aliases: ['Game Master', 'GM'],
        definition: 'Optional 5th-player role dedicated to piloting the Horde / adjudicating rules; not required.',
        sectionId: '1',
        term: 'Game Master (GM)',
    },
    {
        aliases: ['Attacker', 'Defender'],
        definition: 'Fixed sides: Horde is always the Attacker, Players are always the Defender.',
        sectionId: '2.2',
        term: 'Attacker / Defender',
    },
    {
        aliases: ['Deployment layout'],
        definition:
            'A layout selected from the 40K Event Companion with a single Central Objective; Horde Mode has no Primary Missions or Matchups.',
        sectionId: '2.1',
        term: 'Deployment',
    },
    {
        aliases: ['Spawn Zone', 'Spawn Zones', 'the zone'],
        definition:
            "An equal-area subsection of the Horde's deployment zone (2 or 4 of them) from which the Horde spawns each round.",
        sectionId: '2.3',
        term: 'Horde Spawn Zone',
    },
    {
        aliases: [],
        definition:
            'The neutral space between deployment zones; load-bearing for several card effects (Deploy Minefield, Supply Drop).',
        sectionId: '2.3',
        term: "No Man's Land",
    },
    {
        aliases: ['Misery card(s)', 'Misery'],
        definition: '36-card deck of escalating hardship effects revealed each round on a schedule.',
        sectionId: '2.4',
        term: 'Misery Deck',
    },
    {
        aliases: ['Secret Objective(s)'],
        definition: '34-card deck of personal win conditions dealt to each player at setup.',
        sectionId: '2.4',
        term: 'Secret Objectives Deck',
    },
    {
        aliases: ['Secondary Mission(s)'],
        definition: '24-card deck of round-by-round bonus objectives with reward/punishment stakes.',
        sectionId: '2.4',
        term: 'Secondary Mission Deck',
    },
    {
        aliases: ['5 rounds', 'infinite rounds'],
        definition: "Setup choice between 5 battle rounds or infinite ('play-until-you-lose') rounds.",
        sectionId: '2.5',
        term: 'Round Length',
    },
    {
        aliases: ['Primary Faction Rule'],
        definition:
            'A single passive faction-wide rule (one of 22) chosen at setup that buffs Horde units of that faction all game.',
        sectionId: '2.7',
        term: 'Horde Primary Faction Rule',
    },
    {
        aliases: ['Command Points', 'CP'],
        definition:
            "Standard 40K resource, tracked per player; players start with 2 and do not gain 'core' CP in the Command phase.",
        sectionId: '3.1',
        term: 'Command Points (CP)',
    },
    {
        aliases: ['Supply Points', 'SP'],
        definition:
            "Horde Mode's bespoke economy resource, earned via objectives/kills/Secondary Missions and spent in the Resupply Step; floor of 0.",
        sectionId: '3.7',
        term: 'Supply Points (SP)',
    },
    {
        aliases: [],
        definition:
            'An extra Command-phase step, after the Battle-shock step, where players spend Supply Points from the Resupply Table.',
        sectionId: '3.8',
        term: 'Resupply Step',
    },
    {
        aliases: [],
        definition:
            'The 35-entry static price list of purchasable effects players spend Supply Points on; not a shuffled deck.',
        sectionId: '7.1',
        term: 'Resupply Table',
    },
    {
        aliases: ['Fortify', 'Fortified Marker'],
        definition:
            'Placing a named marker on a non-fortified objective to grant it a persistent buff; destroyed if a Horde unit takes the objective.',
        sectionId: '3.9',
        term: 'Fortifying / Fortified',
    },
    {
        aliases: [],
        definition:
            'Standard 40K round unit; Horde Mode overlays escalating Misery/Spawn-Roll effects onto rounds 2, 3-4, and 5+.',
        sectionId: '3.2',
        term: 'Battle Round',
    },
    {
        aliases: ['bracket'],
        definition:
            'The tier (determined by a modified 2D6 roll) of the Spawning Table that determines which unit(s) the Horde may spawn.',
        sectionId: '4.3',
        term: 'Spawn Bracket',
    },
    {
        aliases: [],
        definition: 'The 2D6 + modifiers roll used to determine the Spawn Bracket.',
        sectionId: '4.3',
        term: 'Spawn Roll',
    },
    {
        aliases: ['roll down'],
        definition: 'Spawning-table option: swap 1 unit from bracket N for 2 units from bracket N-1, repeatable.',
        sectionId: '4.4',
        term: 'Roll Down',
    },
    {
        aliases: [],
        definition:
            "The first CHARACTER model ever spawned by the Horde; stands in for 'enemy Warlord' in any rule that references one.",
        sectionId: '4',
        term: 'Horde Warlord',
    },
    {
        aliases: ['Deep Strike'],
        definition:
            'In battle rounds 2-4, Deep-Strike-capable spawns go to reserves for an ingress move instead of direct Spawn Zone placement.',
        sectionId: '4.5a',
        term: 'Deep Strike Deferral',
    },
    {
        aliases: [],
        definition:
            'Standard Core Rules 20.04 strategic-reserves entry move, used by Deep Strike Deferral and several Resupply purchases.',
        sectionId: '4.5a',
        term: 'Ingress Move',
    },
    {
        aliases: [],
        definition:
            'Standard 40K off-table holding area used for deferred Deep Strike spawns and several player purchase effects.',
        sectionId: '4.5a',
        term: 'Strategic Reserves',
    },
    {
        aliases: [],
        definition: 'Step 2 of Spawning: destroy any unit occupying the chosen Spawn Zone before rolling.',
        sectionId: '4.2',
        term: 'Clear Spawn Zone',
    },
    {
        aliases: [],
        definition:
            "The Horde's 3-tier movement-target ranking: closest visible enemy, then closest visible uncontrolled objective, then the Defender's board edge.",
        sectionId: '5.2',
        term: 'Movement Priority',
    },
    {
        aliases: ['side-arms'],
        definition:
            '[CLOSE-QUARTERS] weapons on units with better melee loadouts, or any ranged weapon on an attached Character; ignored when deciding whether advancing costs shooting.',
        sectionId: '5.4',
        term: 'Side-arms',
    },
    {
        aliases: ['Advance'],
        definition: "A move made only when 'advantageous' per 4 specific listed criteria.",
        sectionId: '5.4',
        term: 'Advance Move (Horde)',
    },
    {
        aliases: ['Disembarking'],
        definition: 'Transport-exit logic for Horde units; never ends inside a Spawn Zone.',
        sectionId: '5.5',
        term: 'Disembark Move (Horde)',
    },
    {
        aliases: [],
        definition:
            'The rule that Horde models attack the closest Player unit, possibly splitting attacks model-by-model.',
        sectionId: '5.11',
        term: 'Fight Phase Targeting',
    },
    {
        aliases: ['Pile In'],
        definition: "Horde models always pile in toward the closest Player model's unit, as far as possible.",
        sectionId: '5.9',
        term: 'Pile-In (Horde)',
    },
    {
        aliases: ['Consolidate'],
        definition: 'Horde units always make consolidation moves if possible.',
        sectionId: '5.12',
        term: 'Consolidation (Horde)',
    },
    {
        aliases: ['Fall Back'],
        definition:
            'Engaged Horde units stay engaged unless eligible to shoot/charge after falling back; otherwise fall back max distance, or 2" if planning to re-charge.',
        sectionId: '5.10',
        term: 'Falling Back (Horde)',
    },
    {
        aliases: ['ANTI-X'],
        definition: 'Weapon keyword causing Horde shooters to prioritize the named X-keyword unit type.',
        sectionId: '5.6',
        term: '[ANTI-X] / [X HUNTER]',
    },
    {
        aliases: [],
        definition: 'Weapon keyword causing Horde shooters to prioritize units with a Leader or Support model.',
        sectionId: '5.6',
        term: '[PRECISION]',
    },
    {
        aliases: [],
        definition: 'Weapon keyword causing Horde shooters to prioritize non-INFANTRY, non-SWARM targets.',
        sectionId: '5.6',
        term: '[MELTA]',
    },
] as const;
